import * as LimitActionTypes from '../actions/limits';

import initialState from './initialState';

import { errorResponseHandler } from '../utils/error-utils';

export default (state=initialState.limits, action) => {

    const { payload, type } = action;

    switch(type){

        case LimitActionTypes.LIST_VESSEL_LIMITS:
        case LimitActionTypes.LIST_VESSEL_LIMITS_PENDING:
            return { ...state }

        case LimitActionTypes.LIST_VESSEL_LIMITS_REJECTED:
            return { ...state, error: true, ...errorResponseHandler(payload, 'ListVessel') }

        case LimitActionTypes.LIST_VESSEL_LIMITS_FULFILLED:
            return { ...state, vesselLimits: payload.data }


        case LimitActionTypes.UPDATE_VESSEL_LIMITS:
        case LimitActionTypes.UPDATE_VESSEL_LIMITS_PENDING:
            return { ...state }

        case LimitActionTypes.UPDATE_VESSEL_LIMITS_REJECTED:
            return { ...state, error: true, ...errorResponseHandler(payload, 'VesselLimitUpdate') }

        case LimitActionTypes.UPDATE_VESSEL_LIMITS_FULFILLED:
            let vesselLimit = payload.data;
            return Object.assign({}, state, {
                vesselLimits: [
                    vesselLimit,
                    ...state.vesselLimits
                    
                ],
                vesselLimits_updating: false, 
                updated: 'Vessel Limit updated' });
            
        case LimitActionTypes.LIST_CONSIGNMENT_LIMITS:  
        case LimitActionTypes.LIST_CONSIGNMENT_LIMITS_PENDING:
            return { ...state }

        case LimitActionTypes.LIST_CONSIGNMENT_LIMITS_REJECTED:
            return { ...state, error: true, ...errorResponseHandler(payload, 'ListConsignment') }

        case LimitActionTypes.LIST_CONSIGNMENT_LIMITS_FULFILLED:
            return { ...state, consignmentLimits: payload.data }


        case LimitActionTypes.UPDATE_CONSIGNMENT_LIMITS:
        case LimitActionTypes.UPDATE_CONSIGNMENT_LIMITS_PENDING:
            return { ...state }

        case LimitActionTypes.UPDATE_CONSIGNMENT_LIMITS_REJECTED:
            return { ...state, error: true, ...errorResponseHandler(payload, 'ConsignmentLimitUpdate') }

        case LimitActionTypes.UPDATE_CONSIGNMENT_LIMITS_FULFILLED:
            let consignmentLimit = payload.data;
            return Object.assign({}, state, {
                consignmentLimits : [
                    consignmentLimit,
                    ...state.consignmentLimits
                ],
                consignmentLimits_updating: false,
                 success: 'Consignment Limit updated' });

        default:
            return state
    }
}





// WEBPACK FOOTER //
// ./src/reducers/limits.js